export default __webpack_public_path__ + "static/19-2f039a6f87d6af283e8ff2c12a5516a8.jpg";